import React from "react";
import loadable from "@loadable/component";
import { showHideLoader } from "../../actions/index";

export default {
	component: loadable(() => import(/* webpackChunkName: "addEditItem" */ "./add-item/AddItem"), {
		fallback: <div>Loading...</div>
	})
};
